module.exports = __webpack_public_path__ + "static/media/light-theme-speed.80b4da93.svg";